import React from 'react';
import { Play } from 'lucide-react';
import SectionHeading from './SectionHeading';

const VideoSection = () => {
  return (
    <section className="section-pad bg-blush">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="See Us In Action"
          title="Our"
          accent="Wellness Bar"
          tail="Experience"
          subtitle="Watch how Mr. Coconetto transforms every event into a fresh, tropical moment."
        />

        <div className="mt-12 relative rounded-[2rem] overflow-hidden shadow-floating border border-pink-100 aspect-video bg-white">
          <img
            src="https://images.unsplash.com/photo-1537191072641-5e19cc173c6a?auto=format&fit=crop&w=1600&q=80"
            alt="Wellness Bar Experience"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/30" />
          <a
            href="https://www.youtube.com/@mrcoconetto"
            target="_blank"
            rel="noreferrer"
            className="absolute inset-0 flex items-center justify-center group"
            data-testid="video-section-play-link"
          >
            <span className="w-20 h-20 rounded-full bg-pink-brand text-white flex items-center justify-center shadow-pink-glow group-hover:scale-110 transition-transform">
              <Play className="w-8 h-8 ml-1" />
            </span>
          </a>
          <div className="absolute bottom-6 left-6 text-white drop-shadow">
            <div className="font-script text-lg">Simply Original</div>
            <div className="font-display font-bold text-2xl md:text-3xl">#MR. COCONETTO</div>
            <div className="text-sm text-white/90 font-script">Makes Every Occasion Extra Special!</div>
          </div>
          <a
            href="https://www.youtube.com/@mrcoconetto"
            target="_blank"
            rel="noreferrer"
            className="absolute bottom-6 right-6 rounded-full bg-white text-stone-900 hover:bg-pink-50 text-xs font-semibold px-4 py-2 inline-flex items-center gap-1.5"
            data-testid="video-section-youtube-link"
          >
            <Play className="w-3 h-3 text-pink-brand" /> Watch on YouTube
          </a>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
